import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzRiskScanActionWebComponent } from './component/GzRiskScanActionWebComponent';
import { translateFn } from '../../../../utils/translator.helper';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { CreateTaskRequest } from '../../types';
import { getFormattedDateForTask } from '../../../networkAppContainer/helpers/utils';

export class RiskScanPopUp extends NetworkBasePopUp<GzRiskScanActionWebComponent> {
  protected title = translateFn('Risk scan');
  protected extraDialogConfigs: Partial<GzDialog> = { isWindow: false };
  protected transformToTaskTarget = true;

  protected customSetup() {
    this.popUpContent = new GzRiskScanActionWebComponent();
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const payload: CreateTaskRequest = {
      settings: {
        taskName: this.title + ' ' + getFormattedDateForTask(),
        targets: this.data.targets || [],
        type: Constants.Tasks.Endpoints.TASK_TYPE_IOR_SCAN_PARENT,
      },
    };

    return this.createTask(payload);
  }
}
